import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import ArtefactPage from '@/components/ArtefactPage.vue'
import DashboardPage from '@/components/DashboardPage.vue'
import AdminPage from '@/components/AdminPage.vue'
import LoginPage from '@/components/LoginPage.vue'
import ArtPage from '@/components/ArtPage.vue'
import { useAuthStore } from '@/store/auth'
import ModulePage from '@/components/module/ModulePage.vue'
import ModuleStat from '@/components/module/ModuleStat.vue'
import TrackedArtefacts from '@/components/TrackedArtefacts.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/login',
    name: 'login',
    component: LoginPage
  },
  {
    path: '/',
    name: 'home',
    component: DashboardPage,
    meta: { requiresAdmin: true }
  },
  {
    path: '/artifacts',
    name: 'artifacts',
    component: ArtPage,
    meta: { requiresAdmin: true }
  },
  {
    path: '/module',
    name: 'module',
    component: ModulePage,
    meta: { requiresAdmin: true }
  },
  {
    path: '/module-stat',
    name: 'moduleStat',
    component: ModuleStat,
    meta: { requiresAdmin: true }
  },
  {
    path: '/art/:id',
    name: 'art',
    component: ArtefactPage,
    meta: { requiresAdmin: true }
  },
  {
    path: '/tracked-artefacts',
    name: 'trackedArtefacts',
    component: TrackedArtefacts,
    meta: { requiresAdmin: true }
  },
  {
    path: '/admin',
    name: 'admin',
    component: AdminPage,
    meta: { requiresAdmin: true }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(to => {
  const auth = useAuthStore()

  const requiresAdmin = to.matched.some(r => r.meta.requiresAdmin)

  if (auth.accessToken) {
    return true
  }

  // Если уже залогинен и идёт на login
  if (to.path === '/login' && auth.accessToken) {
    return { path: '/' }
  } else if (requiresAdmin) {
    // Если нет токена → сразу на login
    if (!auth.accessToken) {
      return { path: '/login' }
    }

    // Если токен есть, но роль не admin
    if (auth.user?.role !== 'ADMIN') {
      return { path: '/login' }
    }
  }

  return true
})

export default router
